'use strict';

/**
 *   Compares a past date to current date and parses it in a readable string
 *   returns "8 jaar geleden" / "3 dagen geleden" etc.
 */

var $timeDifferences = $('.js-time-difference');

$timeDifferences.each(function () {
  var elem = this;
  var s = $(elem).html();
  var a = s.split(/[^0-9]/);
  var d = new Date(a[0], a[1] - 1, a[2], a[3], a[4], a[5]);
  $(elem).html(timeDifference(d));
});

function timeDifference(pastDate) {
  // in milliseconds
  let units = {
    year: 24 * 60 * 60 * 1000 * 365,
    month: 24 * 60 * 60 * 1000 * 365 / 12,
    day: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
    second: 1000
  }

  let rtf = new Intl.RelativeTimeFormat('nl', {numeric: 'auto'})
  let getRelativeTime = (d1, d2 = Date.now()) => {
    let elapsed = d1 - d2;
    for (let u in units) {
      if (Math.abs(elapsed) > units[u] || u === 'second') {
        return rtf.format(Math.round(elapsed / units[u]), u);
      }
    }
  }
  return getRelativeTime(pastDate);
};
